import { downloadTreeWiseReport, fetchPositionsTree } from "@api/positionsTree";
import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";

export const usePositionsTree = () => {
  const [positionsTreeData, setPositionsTreeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [positionsTreeDataError, setPositionsTreeDataError] = useState(false);
  const [query, setQuery] = useState<any>(null);
  const { keycloak } = useKeycloak();
  const token = keycloak.token as string;

  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev: any) => ({
      ...prev,
      [key]: value,
    }));

  useEffect(() => {
    if (query) {
      setIsLoading(true);
      fetchPositionsTree(query).then((data) => {
        if (data.status === "SUCCESS") {
          setPositionsTreeData(data.resData?.data);
          setPositionsTreeDataError(false);
        } else {
          setPositionsTreeDataError(true);
        }
        setIsLoading(false);
      });
    }
  }, [query]);

  const downloadReport = async (fileName: string) => {
    setIsLoading(true);
    if (!query) {
      alert("Please select a filter before downloading the report.");
      setIsLoading(false);
      return;
    }
    try {
      await downloadTreeWiseReport(token, fileName, query);
    } catch (error) {
      alert("Error downloading file");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleQuery,
    positionsTreeData,
    positionsTreeDataError,
    isLoading,
    query,
    downloadReport,
  };
};
